import type { RootState } from 'features/app/store/store';

export const selectPreviousCalls = ({ previousCalls }: RootState) =>
  previousCalls.previousCalls;
